module.exports = __webpack_public_path__ + "img/trusted-shop.7f6b77ee.svg";